// extracted by mini-css-extract-plugin
module.exports = {"twitterContainer":"SnsShareModal_twitterContainer__TWD4R","borderBottom":"SnsShareModal_borderBottom__K8L_K"};